var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgRoute(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.99988 12.1875V15.1875M8.99988 12.1875H4.52711C4.03973 12.1875 3.58273 11.9507 3.30166 11.5525L2.11049 9.86502C1.74442 9.34643 1.74442 8.65357 2.11049 8.13498L3.30166 6.44748C3.58273 6.0493 4.03973 5.8125 4.52711 5.8125H8.24988C8.66409 5.8125 8.99988 6.14829 8.99988 6.5625V12.1875ZM9.74988 2.8125H13.4726C13.96 2.8125 14.417 3.0493 14.6981 3.44748L15.8893 5.13498C16.2553 5.65357 16.2553 6.34643 15.8893 6.86502L14.6981 8.55252C14.417 8.9507 13.96 9.1875 13.4726 9.1875H9.74988C9.33567 9.1875 8.99988 8.85171 8.99988 8.4375V3.5625C8.99988 3.14829 9.33567 2.8125 9.74988 2.8125Z",
    stroke: "#FF7926",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRoute);
export default __webpack_public_path__ + "static/media/route.034979e8d6c2978d40282ecca04554ab.svg";
export { ForwardRef as ReactComponent };